<!-- ══════════ Tasas por monto: franjas CLP ↔ VES y tramos USDT ↔ VES (modal) ══════════ -->
<!-- Sin role="dialog": el contenedor de MatDialog ya lo pone. -->
<div class="fe" [attr.aria-busy]="bloqueado">

  <!-- ───── Cabecera fija ───── -->
  <header class="fe__cabecera">
    <div class="fe__cabecera-fila">
      <h2 id="fe-titulo" class="fe__titulo">
        <mat-icon class="fe__titulo-icono" aria-hidden="true">stacked_bar_chart</mat-icon>
        Tasas por monto
      </h2>
      <span class="fe__solo-lectura" *ngIf="soloLectura" role="status"><mat-icon class="fe__candado" aria-hidden="true">lock</mat-icon>Solo lectura</span>

      <button type="button" class="fe__icono-btn fe__cerrar" (click)="cerrar()" [disabled]="bloqueado"
        aria-label="Cerrar" matTooltip="Cerrar">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>

    <!-- Pestañas en dos grupos; bajan de línea en pantallas chicas -->
    <nav class="fe__grupos" aria-label="Par">
      <div class="fe__grupo">
        <span class="fe__grupo-titulo" id="fe-grupo-franjas">Franjas CLP ↔ VES</span>
        <div class="fe__pares" role="tablist" aria-labelledby="fe-grupo-franjas">
          <button type="button" role="tab" class="fe__par" *ngFor="let p of pares"
            [class.is-activo]="!usdt && par === p.par" [attr.aria-selected]="!usdt && par === p.par"
            [disabled]="cargando || bloqueado" (click)="cambiarPar(p.par)">
            {{ p.etiqueta }}
          </button>
        </div>
      </div>
      <div class="fe__grupo">
        <span class="fe__grupo-titulo" id="fe-grupo-tramos">Tramos USDT ↔ VES</span>
        <div class="fe__pares" role="tablist" aria-labelledby="fe-grupo-tramos">
          <button type="button" role="tab" class="fe__par"
            [class.is-activo]="usdt && parUsdt === 'VES-USDT'" [attr.aria-selected]="usdt && parUsdt === 'VES-USDT'"
            [disabled]="bloqueado" (click)="abrirUsdt('VES-USDT')">
            VES → USDT
          </button>
          <button type="button" role="tab" class="fe__par"
            [class.is-activo]="usdt && parUsdt === 'USDT-VES'" [attr.aria-selected]="usdt && parUsdt === 'USDT-VES'"
            [disabled]="bloqueado" (click)="abrirUsdt('USDT-VES')">
            USDT → VES
          </button>
        </div>
      </div>
      <div class="fe__grupo">
        <span class="fe__grupo-titulo" id="fe-grupo-tramos-clp">Tramos CLP ↔ USDT</span>
        <div class="fe__pares" role="tablist" aria-labelledby="fe-grupo-tramos-clp">
          <button type="button" role="tab" class="fe__par"
            [class.is-activo]="usdt && parUsdt === 'CLP-USDT'" [attr.aria-selected]="usdt && parUsdt === 'CLP-USDT'"
            [disabled]="bloqueado" (click)="abrirUsdt('CLP-USDT')">
            CLP → USDT
          </button>
          <button type="button" role="tab" class="fe__par"
            [class.is-activo]="usdt && parUsdt === 'USDT-CLP'" [attr.aria-selected]="usdt && parUsdt === 'USDT-CLP'"
            [disabled]="bloqueado" (click)="abrirUsdt('USDT-CLP')">
            USDT → CLP
          </button>
        </div>
      </div>
    </nav>

    <p class="fe__datos" *ngIf="editor && !usdt && !enMargenes">
      <span>Mercado <b>{{ n(editor.mid, 4) }}</b></span>
      <span class="fe__sep" aria-hidden="true">·</span>
      <span>Base con comisión <b>{{ n(editor.base, 4) }}</b></span>
      <span class="fe__sep" aria-hidden="true">·</span>
      <span>Descuento por franja <b>{{ n(editor.insumos?.descuentoFiat, 4) }}</b></span>
      <span class="fe__unidad">VES por CLP</span>
    </p>

    <!-- Motor Márgenes: spot cruzado del par y el rango de márgenes (de Actualizar Parámetros) -->
    <p class="fe__datos" *ngIf="editor && !usdt && enMargenes">
      <span class="fe__motor">Motor Márgenes</span>
      <span>Spot cruzado <b>{{ formatoTasaVes(spotCruzado) }}</b> <span class="fe__unidad">{{ unidadSpot }}</span></span>
      <span class="fe__sep" aria-hidden="true">·</span>
      <span>Margen <b>{{ formatoMargen(margenesPar?.maximo) }}</b> (montos chicos) a <b>{{ formatoMargen(margenesPar?.minimo) }}</b> (montos grandes)</span>
    </p>

    <!-- Guardado → Aplicando… → Aplicado a las HH:MM -->
    <ol class="fe__pasos" *ngIf="pasoVisible as e" aria-label="Estado del guardado" aria-live="polite">
      <li class="fe__paso is-hecho">✓ Guardado</li>
      <li class="fe__paso-flecha" aria-hidden="true">→</li>
      <li class="fe__paso" [class.is-actual]="e.paso === 'aplicando'" [class.is-hecho]="e.paso === 'aplicado'"
        [class.is-ambar]="e.paso === 'se-aplicara'">
        Aplicando…
      </li>
      <li class="fe__paso-flecha" aria-hidden="true">→</li>
      <li class="fe__paso" [class.is-hecho]="e.paso === 'aplicado'" [class.is-ambar]="e.paso === 'se-aplicara'">
        {{ e.paso === 'aplicado' ? textoAplicado : (e.paso === 'se-aplicara' ? 'Se aplicará en la próxima actualización' : 'Aplicado') }}
      </li>
    </ol>

    <div class="fe__aviso fe__aviso--ambar" *ngIf="rigeConstante && !usdt" role="status">
      <mat-icon aria-hidden="true">warning</mat-icon>
      Las franjas de la tabla no se pudieron usar; rigen las de siempre.
    </div>

    <!-- MARGENES sin márgenes del par: no se guarda (el error del back sale en «Vista previa») -->
    <div class="fe__aviso fe__aviso--rojo fe__aviso--inicio" *ngIf="faltanMargenes && !usdt" role="alert">
      <mat-icon aria-hidden="true">error</mat-icon>
      <span>{{ textoFaltanMargenes }}</span>
    </div>
  </header>

  <!-- ───── Pestañas de tramos USDT: cuerpo y pie propios, mismas clases ───── -->
  <app-tramos-usdt-editor *ngIf="usdt && parUsdt === 'VES-USDT'" [leidos]="leidosUsdt" [puedeEditar]="puedeEditar"
    (guardado)="alGuardarUsdt($event)" (cerrarPedido)="cerrar()" (editado)="alEditarUsdt()"
    (comisionPedida)="pedirComision()"></app-tramos-usdt-editor>
  <!-- USDT → VES: la comisión es de solo lectura (se cambia en el panel). -->
  <app-tramos-usdt-editor *ngIf="usdt && parUsdt === 'USDT-VES'" [leidos]="leidosUsdt" par="USDT-VES" [puedeEditar]="puedeEditar"
    (guardado)="alGuardarUsdt($event)" (cerrarPedido)="cerrar()" (editado)="alEditarUsdt()"></app-tramos-usdt-editor>
  <!-- CLP ↔ USDT (22/10/2026): mismo editor, spot USD/CLP, descuento base de solo lectura y tope. -->
  <app-tramos-usdt-editor *ngIf="usdt && parUsdt === 'CLP-USDT'" [leidos]="leidosUsdt" par="CLP-USDT" [puedeEditar]="puedeEditar"
    (guardado)="alGuardarUsdt($event)" (cerrarPedido)="cerrar()" (editado)="alEditarUsdt()"></app-tramos-usdt-editor>
  <app-tramos-usdt-editor *ngIf="usdt && parUsdt === 'USDT-CLP'" [leidos]="leidosUsdt" par="USDT-CLP" [puedeEditar]="puedeEditar"
    (guardado)="alGuardarUsdt($event)" (cerrarPedido)="cerrar()" (editado)="alEditarUsdt()"></app-tramos-usdt-editor>

  <ng-container *ngIf="!usdt">
  <!-- ───── Cuerpo con scroll interno ───── -->
  <div class="fe__cuerpo">

    <div *ngIf="cargando" class="fe__cargando">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Cargando franjas…</span>
    </div>

    <div *ngIf="!cargando && errorCarga" class="fe__aviso fe__aviso--rojo" role="alert">
      <span>{{ errorCarga }}</span>
      <button type="button" class="fe__btn fe__btn--secundario" (click)="cargar()">Reintentar</button>
    </div>

    <ng-container *ngIf="!cargando && editor && borrador">
      <p class="fe__ayuda">{{ enMargenes ? textoRepartoAutomatico : ayudaDescuentos }} <span class="fe__ayuda-nota">{{ notaMontos }}</span></p>

      <!-- Barra visual en vivo (escala logarítmica entre mínimo y máximo) -->
      <div class="fe__barra" *ngIf="segmentos.length" role="img"
        [attr.aria-label]="segmentos.length + ' franjas entre el mínimo y el máximo'">
        <div class="fe__segmento" *ngFor="let s of segmentos; let i = index; trackBy: trackIndice"
          [style.width.%]="s.ancho"
          [class.is-par]="i % 2 === 1"
          [class.is-simulada]="filaSimulada === i"
          [matTooltip]="s.letra + ': ' + etiquetaRango(s.desde, s.hasta)">
          <span class="fe__segmento-letra">{{ s.letra }}</span>
          <span class="fe__segmento-rango">{{ n(s.desde, 0) }} – {{ n(s.hasta, 0) }}</span>
          <span class="fe__segmento-tasa">{{ n(tasaUsada(i).tasa, 4) }}</span>
        </div>
      </div>

      <div class="fe__grid">

        <!-- ───── Izquierda: tabla ───── -->
        <section class="fe__zona-tabla" aria-label="Franjas">
          <table class="fe__tabla">
            <thead>
              <tr>
                <th scope="col">Franja</th>
                <th scope="col">Desde – Hasta ({{ par === 'VES-CLP' ? 'CLP equiv.' : 'CLP' }})</th>
                <ng-container *ngIf="!enMargenes">
                <th scope="col" class="is-num">Tasa al cliente</th>
                <th scope="col">
                  <span class="fe__th-con-accion">
                    Descuento vs base
                    <button type="button" class="fe__chip-btn" (click)="automatico()" *ngIf="!soloLectura"
                      [disabled]="!editable || !filas.length || todasAutomaticas"
                      matTooltip="Vuelve a poner los descuentos por posición: la más grande 0, la anterior 1, y así">
                      Automático
                    </button>
                  </span>
                </th>
                <th scope="col" class="is-num">Tu ganancia %</th>
                </ng-container>
                <!-- Motor Márgenes: el margen es automático y de solo lectura -->
                <ng-container *ngIf="enMargenes">
                <th scope="col" class="is-num">Margen aplicado (automático)</th>
                <th scope="col" class="is-num">Tasa al cliente</th>
                <th scope="col" class="is-num">Tasa de la ruta</th>
                </ng-container>
                <th scope="col">Recibe por {{ n(montoEjemplo, 0) }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let f of filas; let i = index; trackBy: trackFila">
              <tr [class.is-simulada]="filaSimulada === i"
                [class.is-negativa]="negativa(i)"
                [class.is-tope]="pasaTope(i)"
                [attr.aria-current]="filaSimulada === i ? 'true' : null">

                <!-- Franja -->
                <td class="fe__celda-franja">
                  <span class="fe__letra">{{ f.letra }}</span>
                  <span class="fe__badge fe__badge--azul" *ngIf="!f.clave">nueva</span>
                  <button type="button" class="fe__icono-btn fe__quitar" (click)="quitar(i)" *ngIf="!soloLectura"
                    [disabled]="!editable || filas.length <= 1"
                    [attr.aria-label]="'Quitar la franja ' + f.letra"
                    [matTooltip]="filas.length <= 1 ? 'Tiene que quedar al menos una franja' : 'Quitar franja (se apaga; su rango lo toma la vecina)'">
                    <mat-icon aria-hidden="true">delete_outline</mat-icon>
                  </button>
                </td>

                <!-- Desde – Hasta -->
                <td>
                  <ng-container *ngIf="!soloLectura; else rangoTexto">
                    <div class="fe__rango">
                      <ng-container *ngIf="desdeEditable(i); else desdeFijo">
                        <input type="number" min="1" step="1" class="fe__input"
                          [class.is-error]="!!errorDesde(i)"
                          [ngModel]="borrador.minimo" (ngModelChange)="cambiarDesde(i, $event)"
                          [disabled]="!editable"
                          [attr.aria-label]="'Desde de la franja ' + f.letra + ' (monto mínimo)'"
                          [attr.aria-invalid]="!!errorDesde(i)" />
                      </ng-container>
                      <ng-template #desdeFijo>
                        <span class="fe__fijo" matTooltip="Se ajusta solo con el Hasta anterior">
                          <mat-icon class="fe__candado" aria-hidden="true">lock</mat-icon>
                          {{ n(desde(i), 0) }}
                        </span>
                      </ng-template>
                      <span class="fe__rango-sep" aria-hidden="true">–</span>
                      <input type="number" min="1" step="1" class="fe__input"
                        [class.is-error]="!!errorHasta(i)"
                        [ngModel]="hastaVisible(i)" (ngModelChange)="cambiarHasta(i, $event)"
                        [disabled]="!editable"
                        [attr.aria-label]="'Hasta de la franja ' + f.letra + (esUltima(i) ? ' (monto máximo)' : '')"
                        [attr.aria-invalid]="!!errorHasta(i)" />
                    </div>
                    <span class="fe__badge fe__badge--verde" *ngIf="desdeEditable(i)">mín.</span>
                    <span class="fe__badge fe__badge--verde" *ngIf="esUltima(i)">máx.</span>
                    <p class="fe__error-campo" *ngIf="errorDesde(i)">{{ errorDesde(i) }}</p>
                    <p class="fe__error-campo" *ngIf="errorHasta(i)">{{ errorHasta(i) }}</p>
                  </ng-container>
                  <ng-template #rangoTexto>
                    <span class="fe__texto-num">{{ n(desde(i), 0) }} – {{ n(hasta(i), 0) }}</span>
                  </ng-template>
                </td>

                <ng-container *ngIf="!enMargenes">
                <!-- Tasa al cliente -->
                <td class="is-num">
                  <span class="fe__tasa" [matTooltip]="detalleTasa(i)">
                    {{ n(tasaUsada(i).tasa, 4) }}
                    <mat-icon *ngIf="!tasaUsada(i).oficial" class="fe__estimada"
                      aria-label="Estimada en tu navegador">schedule</mat-icon>
                  </span>
                </td>

                <!-- Descuento vs base (y la cantidad de descuentos, que es lo que se edita) -->
                <td>
                  <span class="fe__texto-num">{{ pct(descuentoBase(i), true, true) }}</span>
                  <ng-container *ngIf="!soloLectura; else descuentosTexto">
                    <label class="fe__descuentos">
                      <input type="number" step="1" min="0" [max]="descuentosMax" class="fe__input fe__input--corto"
                        [class.is-error]="!!errorDescuentos(f)"
                        [ngModel]="f.descuentos" (ngModelChange)="cambiarDescuentos(f, $event)"
                        [disabled]="!editable"
                        [attr.aria-label]="'Descuentos de la franja ' + f.letra"
                        [attr.aria-invalid]="!!errorDescuentos(f)" />
                      <span class="fe__subtexto">descuentos</span>
                    </label>
                  </ng-container>
                  <ng-template #descuentosTexto>
                    <span class="fe__subtexto">{{ f.descuentos ?? '—' }} descuentos</span>
                  </ng-template>
                  <span class="fe__badge fe__badge--ambar" *ngIf="!esAutomatico(i)" matTooltip="Escrito a mano">manual</span>
                  <p class="fe__error-campo" *ngIf="errorDescuentos(f)">{{ errorDescuentos(f) }}</p>
                </td>

                <!-- Tu ganancia % -->
                <td class="is-num">
                  <span class="fe__texto-num" [class.is-ambar]="negativa(i)" [class.is-rojo]="pasaTope(i)">
                    {{ pct(ganancia(i)) }}
                  </span>
                  <span class="fe__subtexto is-ambar" *ngIf="negativa(i)">{{ textoNegativa }}</span>
                </td>
                </ng-container>

                <!-- Motor Márgenes: margen automático, tasa al cliente y tasa de la ruta (de la vista previa del back).
                     Con la vista previa vieja, la última oficial y el reloj de «pendiente» en las tres. -->
                <ng-container *ngIf="enMargenes">
                <td class="is-num">
                  <span class="fe__con-pendiente">
                    <span class="fe__texto-num" [class.is-rojo]="pasaTope(i)">{{ formatoMargen(margenAplicado(i)) }}</span>
                    <mat-icon *ngIf="!filaAlDia(i)" class="fe__estimada"
                      aria-label="Pendiente: se recalcula con la vista previa">schedule</mat-icon>
                  </span>
                  <span class="fe__subtexto">automático</span>
                </td>
                <td class="is-num">
                  <span class="fe__tasa" [matTooltip]="detalleTasa(i)">
                    {{ textoTasaCliente(i) }}
                    <mat-icon *ngIf="!tasaUsada(i).oficial" class="fe__estimada"
                      aria-label="Pendiente: se recalcula con la vista previa">schedule</mat-icon>
                  </span>
                </td>
                <td class="is-num">
                  <span class="fe__con-pendiente">
                    <span class="fe__texto-num">{{ textoTasaRuta(i) }}</span>
                    <mat-icon *ngIf="!filaAlDia(i)" class="fe__estimada"
                      aria-label="Pendiente: se recalcula con la vista previa">schedule</mat-icon>
                  </span>
                </td>
                </ng-container>

                <!-- Recibe por 100.000 -->
                <td>
                  <div class="fe__pastilla" *ngIf="pastilla(i) as p"
                    [matTooltip]="tasaUsada(i).oficial ? 'Con la tasa oficial' : (enMargenes ? 'Con la última tasa oficial (pendiente)' : 'Con la tasa estimada en tu navegador')">
                    <span class="fe__pastilla-monto">{{ p.recibe }}</span>
                    <span class="fe__pastilla-por">{{ p.por }}</span>
                  </div>
                  <span *ngIf="!pastilla(i)">—</span>
                </td>
              </tr>
              <!-- VES→CLP con demasiado margen: aviso en la fila, no bloquea -->
              <tr class="fe__fila-tope" *ngIf="pasaTope(i)">
                <td colspan="6" role="alert"><span class="fe__fila-tope-texto">{{ textoTope }}</span></td>
              </tr>
              </ng-container>

              <!-- Última fila: agregar -->
              <tr class="fe__fila-agregar" *ngIf="!soloLectura">
                <td colspan="6">
                  <button type="button" class="fe__btn fe__btn--fantasma" (click)="agregar()"
                    [disabled]="!editable || !filas.length"
                    matTooltip="La última franja se corta y la nueva llega hasta el monto máximo">
                    <mat-icon aria-hidden="true">add</mat-icon>
                    Agregar franja
                  </button>
                  <button type="button" class="fe__btn fe__btn--secundario" *ngIf="hayCambios" (click)="descartar()" [disabled]="guardando">
                    Descartar cambios
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="errorAccion" class="fe__aviso fe__aviso--rojo" role="alert">{{ errorAccion }}</div>

          <p class="fe__nota" *ngIf="!enMargenes">
            <mat-icon class="fe__estimada" aria-hidden="true">schedule</mat-icon>
            = estimada en tu navegador. Sin ícono = tasa oficial del servidor, que es la que vale.
          </p>
          <p class="fe__nota" *ngIf="enMargenes">
            <mat-icon class="fe__estimada" aria-hidden="true">schedule</mat-icon>
            = pendiente: se recalcula con la vista previa. Sin ícono = tasa oficial del servidor, que es la que vale.
          </p>
        </section>

        <!-- ───── Derecha: panel ───── -->
        <aside class="fe__panel" aria-label="Simulación y guardado">

          <!-- Simular un envío -->
          <section class="fe__tarjeta fe__tarjeta--verde">
            <label for="fe-simular" class="fe__tarjeta-titulo">Simular un envío</label>
            <div class="fe__sim-entrada">
              <input id="fe-simular" type="number" min="1" step="1000" class="fe__input fe__input--ancho"
                [(ngModel)]="simMonto" aria-describedby="fe-simular-resultado" />
              <span class="fe__moneda">{{ monedas.paga }}</span>
            </div>
            <div id="fe-simular-resultado" aria-live="polite">
              <ng-container *ngIf="simulacion as sim">
                <div class="fe__sim-resultado" *ngIf="sim.indice >= 0">
                  <span class="fe__sim-recibe">{{ simRecibe }}</span>
                  <span class="fe__sim-detalle">
                    Franja <b>{{ filas[sim.indice].letra }}</b> · {{ etiquetaRango(desde(sim.indice), hasta(sim.indice)) }}
                  </span>
                  <span class="fe__sim-detalle">
                    Tasa {{ n(simTasa?.tasa, 4) }}
                    <span class="fe__badge" [class.fe__badge--verde-solido]="simTasa?.oficial" [class.fe__badge--ambar]="!simTasa?.oficial">
                      {{ simTasa?.oficial ? 'oficial' : (enMargenes ? 'pendiente' : 'estimada') }}
                    </span>
                  </span>
                </div>
                <div class="fe__aviso fe__aviso--rojo" *ngIf="sim.indice < 0" role="alert">{{ sim.mensaje }}</div>
              </ng-container>
            </div>
            <p class="fe__nota" *ngIf="par === 'VES-CLP'">La franja se ubica con el monto en VES convertido a CLP al precio de mercado.</p>
          </section>

          <!-- Resumen de cambios -->
          <section class="fe__tarjeta" *ngIf="!soloLectura">
            <h3 class="fe__tarjeta-titulo">Resumen de cambios</h3>
            <p class="fe__vacio" *ngIf="!cambiosLista.length">Sin cambios.</p>
            <ul class="fe__lista" *ngIf="cambiosLista.length">
              <li *ngFor="let c of cambiosLista">{{ c }}</li>
            </ul>
          </section>

          <!-- Estado de la vista previa -->
          <section class="fe__tarjeta" aria-live="polite">
            <div class="fe__estado-fila">
              <h3 class="fe__tarjeta-titulo">Vista previa</h3>
              <button type="button" class="fe__chip-btn" (click)="previsualizar()"
                [disabled]="previsualizando || guardando || !!erroresLocales.length"
                matTooltip="Vuelve a pedir la tasa oficial ahora">
                Actualizar
              </button>
            </div>
            <p class="fe__estado fe__estado--azul" *ngIf="previsualizando">
              <mat-spinner diameter="14"></mat-spinner> Calculando…
            </p>
            <p class="fe__estado" *ngIf="!previsualizando && vistaVieja">Esperando a que termines de escribir…</p>
            <p class="fe__estado fe__estado--verde" *ngIf="!previsualizando && vista && !vistaVieja && vista.ok">
              <mat-icon aria-hidden="true">check_circle</mat-icon> Tasas oficiales al día
            </p>
            <ul class="fe__lista fe__lista--rojo" *ngIf="errores.length" role="alert">
              <li *ngFor="let e of errores">{{ e }}</li>
            </ul>
            <ul class="fe__lista fe__lista--ambar" *ngIf="advertencias.length">
              <li *ngFor="let a of advertencias">{{ a }}</li>
            </ul>
          </section>

          <!-- Motivo -->
          <section class="fe__tarjeta" *ngIf="!soloLectura">
            <label for="fe-motivo" class="fe__tarjeta-titulo">Motivo del cambio <span class="fe__obligatorio">(obligatorio)</span></label>
            <textarea id="fe-motivo" rows="2" class="fe__input fe__input--area" [(ngModel)]="motivo"
              [maxlength]="motivoMax" [disabled]="!editable"
              [class.is-error]="!!motivo && !motivoValido"
              placeholder="Por ejemplo: agrego una franja desde 1.000.000 CLP"></textarea>
            <p class="fe__error-campo" *ngIf="motivo && !motivoValido">Escribe entre 5 y 255 caracteres.</p>
          </section>

          <!-- Guardado sin grabar las tasas (`motivoNoAplicado`): el mensaje del back, en ámbar -->
          <div class="fe__aviso" *ngIf="mensaje" role="status"
            [class.fe__aviso--verde]="!mensajeAviso" [class.fe__aviso--ambar]="mensajeAviso">{{ mensaje }}</div>
        </aside>
      </div>
    </ng-container>
  </div>

  <!-- ───── Pie fijo ───── -->
  <footer class="fe__pie">
    <div class="fe__historial" *ngIf="historialAbierto" id="fe-historial">
      <p class="fe__vacio" *ngIf="!historialItems.length && !cargandoHistorial">Sin cambios registrados.</p>
      <div class="fe__tabla-caja" *ngIf="historialItems.length">
        <table class="fe__tabla fe__tabla--historial" [class.is-cargando]="cargandoHistorial">
          <thead>
            <tr>
              <th scope="col">Fecha</th>
              <th scope="col">Franja</th>
              <th scope="col">Acción</th>
              <th scope="col">Cambio</th>
              <th scope="col">Quién</th>
              <th scope="col">Motivo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let h of historialItems">
              <td class="is-nowrap">{{ h.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
              <td class="is-mono">{{ h.clave }}</td>
              <td><b>{{ h.accion }}</b></td>
              <td>{{ resumenCambio(h) || '—' }}</td>
              <td>{{ h.editadoPor || '—' }}</td>
              <td>{{ h.motivo || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="fe__error-campo" *ngIf="errorHistorial" role="alert">{{ errorHistorial }}</p>
      <div class="fe__paginacion" *ngIf="hayPaginacion">
        <button type="button" class="fe__btn fe__btn--secundario" (click)="irAPagina(historialPagina - 1)"
          [disabled]="historialPagina <= 1 || cargandoHistorial">‹ Anteriores</button>
        <span aria-live="polite">{{ cargandoHistorial ? 'Cargando…' : 'Página ' + historialPagina + ' de ' + paginasHistorial }}</span>
        <button type="button" class="fe__btn fe__btn--secundario" (click)="irAPagina(historialPagina + 1)"
          [disabled]="historialPagina >= paginasHistorial || cargandoHistorial">Siguientes ›</button>
      </div>
    </div>

    <div class="fe__pie-fila">
      <button type="button" class="fe__btn fe__btn--texto" (click)="toggleHistorial()"
        [attr.aria-expanded]="historialAbierto" aria-controls="fe-historial" [disabled]="!editor">
        Historial ({{ historialTotal }})
        <mat-icon aria-hidden="true">{{ historialAbierto ? 'expand_more' : 'chevron_right' }}</mat-icon>
      </button>

      <div class="fe__pie-acciones">
        <span class="fe__pie-motivo fe__pie-motivo--candado" *ngIf="soloLectura">
          <mat-icon aria-hidden="true">lock</mat-icon>{{ textoSoloLectura }}
        </span>
        <span class="fe__pie-motivo" *ngIf="!soloLectura && !puedeGuardar && !guardando && editor">{{ motivoNoGuardar }}</span>
        <button type="button" class="fe__btn fe__btn--secundario" (click)="cerrar()" [disabled]="guardando">
          {{ soloLectura ? 'Cerrar' : 'Cancelar' }}
        </button>
        <button type="button" class="fe__btn fe__btn--primario" (click)="guardar()" [disabled]="!puedeGuardar" *ngIf="!soloLectura"
          [matTooltip]="motivoNoGuardar" [matTooltipDisabled]="puedeGuardar || guardando">
          <mat-spinner *ngIf="guardando" diameter="16" class="fe__spinner-blanco"></mat-spinner>
          {{ guardando ? 'Guardando…' : 'Guardar franjas' }}
        </button>
      </div>
    </div>
  </footer>

  <!-- Bloqueo mientras guarda: no se edita ni se cierra hasta que responde el back -->
  <div class="fe__bloqueo" *ngIf="guardando" role="status" aria-live="assertive">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Guardando…</span>
  </div>
  </ng-container>
</div>
